import script from "./UploadNewCustomerAssumption.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadNewCustomerAssumption.vue?vue&type=script&setup=true&lang=js"

import "./UploadNewCustomerAssumption.vue?vue&type=style&index=0&id=45bbc2dc&lang=css"

const __exports__ = script;

export default __exports__